import { auth } from '../firebase';
import { buildApiUrl } from '../config/env';
export const createChatOnServer = async ({ modelName, multiModel = false, projectId = null }) => {
  const currentUser = auth.currentUser;
  if (!currentUser) {
    throw new Error('User must be authenticated to create a chat');
  }

  const authToken = await currentUser.getIdToken();
  const response = await fetch(buildApiUrl('/chats'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${authToken}`,
    },
    body: JSON.stringify({ modelName, multiModel, projectId }),
  });

  if (!response.ok) {
    let errorMessage = 'Failed to create chat';
    try {
      const errorBody = await response.json();
      if (errorBody?.error) {
        errorMessage = errorBody.error;
      }
    } catch (error) {
      // Ignore JSON parse errors and use default message
    }
    throw new Error(errorMessage);
  }

  return response.json();
};

export const updateChatTopicOnServer = async (chatId, topic) => {
  const currentUser = auth.currentUser;
  if (!currentUser) {
    throw new Error('User must be authenticated to update a chat');
  }

  const authToken = await currentUser.getIdToken();
  const response = await fetch(buildApiUrl(`/chats/${chatId}/topic`), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${authToken}`,
    },
    body: JSON.stringify({ topic }),
  });

  if (!response.ok) {
    let errorMessage = 'Failed to update chat topic';
    try {
      const errorBody = await response.json();
      if (errorBody?.error) {
        errorMessage = errorBody.error;
      }
    } catch (error) {
      // Ignore JSON parse errors and use default message
    }
    throw new Error(errorMessage);
  }

  return response.json();
};
